// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/users.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/add.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analysis_widget_title_wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.analysis_widget_filter_icon {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 16px;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.2s ease;
}

.analysis_widget_filter_icon:hover {
    opacity: 1;
}

.analysis_widget_filter_icon--active {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    opacity: 0.7;
}

.analysis_widget_filter_icon--active:hover {
    opacity: 1;
}

.analysis_widget_add_wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    transition: opacity 0.2s ease;
    opacity: 0.7;
}

.analysis_widget_add_wrapper:hover {
    opacity: 1;
}

.analysis_widget_add_icon {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 12.5px;
    background-position: center;
    background-repeat: no-repeat;
}

.analysis_widget_add_text {
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    color: #1D1D1F;
    white-space: nowrap;
}

.analysis_widget_empty {
    padding: 20px;
    text-align: center;
    color: #979797;
    font-size: calc(14px * var(--fontScaler));
}

.analysis_widget_loading {
    padding: 20px;
    text-align: center;
    color: #979797;
    font-size: calc(14px * var(--fontScaler));
}

.analysis_widget_empty_folder {
    padding: 15px;
    text-align: center;
    color: #B8B8B8;
    font-size: calc(13px * var(--fontScaler));
}

.analysis_widget_filter {
    padding: 10px 14px;
    flex-shrink: 0;
}

.analysis_widget_filter_label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    user-select: none;
}

.analysis_widget_filter_label input[type="checkbox"] {
    cursor: pointer;
    width: 16px;
    height: 16px;
}

.analysis_widget_filter_text {
    font-size: calc(13px * var(--fontScaler));
    color: #555;
}

.analysis_widget_breadcrumbs {
    margin: 12px 14px;
    padding-bottom: 8px;
    border-bottom: 1px solid #E2E9FC;
    flex-shrink: 0;
}

.analysis_widget_content {
    display: flex;
    flex-direction: column;
    gap: 7px;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
    padding-right: 5px;
}

.dashboard_main_analysis_folders {
    display: flex;
    flex-direction: column;
    gap: 7px;
    padding-top: 24px;
}

/* Scrollbar for analysis content */
.analysis_widget_content::-webkit-scrollbar {
    width: 6px;
}

.analysis_widget_content::-webkit-scrollbar-track {
    background: transparent;
}

.analysis_widget_content::-webkit-scrollbar-thumb {
    background: #E5E9F2;
    border-radius: 3px;
}

.analysis_widget_content::-webkit-scrollbar-thumb:hover {
    background: #D5D9E2;
}

/* File viewing popup */
.analysis_file_popup_overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.analysis_file_popup_content {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 900px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.analysis_file_popup_header {
    padding: 20px 24px;
    border-bottom: 1px solid #E2E9FC;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
}

.analysis_file_popup_title {
    font-size: calc(18px * var(--fontScaler));
    font-weight: 600;
    color: #333;
}

.analysis_file_popup_close {
    background: none;
    border: none;
    font-size: calc(24px * var(--fontScaler));
    color: #999;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: all 0.2s;
}

.analysis_file_popup_close:hover {
    background: #F5F5F5;
    color: #333;
}

.analysis_file_popup_body {
    padding: 20px 24px;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
}

.analysis_file_popup_body::-webkit-scrollbar {
    width: 8px;
}

.analysis_file_popup_body::-webkit-scrollbar-track {
    background: #F5F5F5;
    border-radius: 4px;
}

.analysis_file_popup_body::-webkit-scrollbar-thumb {
    background: #D5D9E2;
    border-radius: 4px;
}

.analysis_file_popup_body::-webkit-scrollbar-thumb:hover {
    background: #B5B9C2;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/analysisWidget/AnalysisWidget.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAAoD;IACpD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAAmD;IACnD,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,OAAO;IACP,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;AACrB;;AAEA,mCAAmC;AACnC;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;IACzC,WAAW;IACX,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".analysis_widget_title_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.analysis_widget_filter_icon {\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/user.svg');\n    background-size: 16px;\n    background-position: center;\n    background-repeat: no-repeat;\n    cursor: pointer;\n    opacity: 0.7;\n    transition: opacity 0.2s ease;\n}\n\n.analysis_widget_filter_icon:hover {\n    opacity: 1;\n}\n\n.analysis_widget_filter_icon--active {\n    background-image: url('../../../../assets/users.svg');\n    opacity: 0.7;\n}\n\n.analysis_widget_filter_icon--active:hover {\n    opacity: 1;\n}\n\n.analysis_widget_add_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    cursor: pointer;\n    transition: opacity 0.2s ease;\n    opacity: 0.7;\n}\n\n.analysis_widget_add_wrapper:hover {\n    opacity: 1;\n}\n\n.analysis_widget_add_icon {\n    width: 24px;\n    height: 24px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/add.svg');\n    background-size: 12.5px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.analysis_widget_add_text {\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    color: #1D1D1F;\n    white-space: nowrap;\n}\n\n.analysis_widget_empty {\n    padding: 20px;\n    text-align: center;\n    color: #979797;\n    font-size: calc(14px * var(--fontScaler));\n}\n\n.analysis_widget_loading {\n    padding: 20px;\n    text-align: center;\n    color: #979797;\n    font-size: calc(14px * var(--fontScaler));\n}\n\n.analysis_widget_empty_folder {\n    padding: 15px;\n    text-align: center;\n    color: #B8B8B8;\n    font-size: calc(13px * var(--fontScaler));\n}\n\n.analysis_widget_filter {\n    padding: 10px 14px;\n    flex-shrink: 0;\n}\n\n.analysis_widget_filter_label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    user-select: none;\n}\n\n.analysis_widget_filter_label input[type=\"checkbox\"] {\n    cursor: pointer;\n    width: 16px;\n    height: 16px;\n}\n\n.analysis_widget_filter_text {\n    font-size: calc(13px * var(--fontScaler));\n    color: #555;\n}\n\n.analysis_widget_breadcrumbs {\n    margin: 12px 14px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid #E2E9FC;\n    flex-shrink: 0;\n}\n\n.analysis_widget_content {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n    overflow-y: auto;\n    flex: 1;\n    min-height: 0;\n    padding-right: 5px;\n}\n\n.dashboard_main_analysis_folders {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n    padding-top: 24px;\n}\n\n/* Scrollbar for analysis content */\n.analysis_widget_content::-webkit-scrollbar {\n    width: 6px;\n}\n\n.analysis_widget_content::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.analysis_widget_content::-webkit-scrollbar-thumb {\n    background: #E5E9F2;\n    border-radius: 3px;\n}\n\n.analysis_widget_content::-webkit-scrollbar-thumb:hover {\n    background: #D5D9E2;\n}\n\n/* File viewing popup */\n.analysis_file_popup_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.analysis_file_popup_content {\n    background: white;\n    border-radius: 12px;\n    width: 90%;\n    max-width: 900px;\n    max-height: 85vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.analysis_file_popup_header {\n    padding: 20px 24px;\n    border-bottom: 1px solid #E2E9FC;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.analysis_file_popup_title {\n    font-size: calc(18px * var(--fontScaler));\n    font-weight: 600;\n    color: #333;\n}\n\n.analysis_file_popup_close {\n    background: none;\n    border: none;\n    font-size: calc(24px * var(--fontScaler));\n    color: #999;\n    cursor: pointer;\n    padding: 0;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    transition: all 0.2s;\n}\n\n.analysis_file_popup_close:hover {\n    background: #F5F5F5;\n    color: #333;\n}\n\n.analysis_file_popup_body {\n    padding: 20px 24px;\n    overflow-y: auto;\n    flex: 1;\n    min-height: 0;\n}\n\n.analysis_file_popup_body::-webkit-scrollbar {\n    width: 8px;\n}\n\n.analysis_file_popup_body::-webkit-scrollbar-track {\n    background: #F5F5F5;\n    border-radius: 4px;\n}\n\n.analysis_file_popup_body::-webkit-scrollbar-thumb {\n    background: #D5D9E2;\n    border-radius: 4px;\n}\n\n.analysis_file_popup_body::-webkit-scrollbar-thumb:hover {\n    background: #B5B9C2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
